import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  }
};

const detectOptions = {
  order: ['querystring', 'localStorage'],
  lookupLocalStorage: 'lang',
  lookupQuerystring: 'lang',
  caches: ['localStorage'],
  checkWhitelist: true
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: detectOptions,
    resources,
    fallbackLng: 'en',
    whitelist: ['en', 'ru'],
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'li', 'a', 'u', 'ol', 'ul', 'p', 'b']
    }
  });

export default i18n;
